import { createFileRoute } from "@tanstack/react-router";
import { VendorRegistryPage } from "@/components/vendor/registry/VendorRegistryPage";

export const Route = createFileRoute("/vendor/registry")({
  head: () => ({ meta: [{ title: "Finanzen · Venue Portal" }] }),
  component: VendorRegistryPage,
});
